/* ProductTileSwatches is a custom element for DKNY */
/* (Not part of original Maker theme) */
class ProductTileSwatches extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
    //window.console.log('ProductTileSwatches connectedCallback');
    this.productTile = this.closest('.product--root');
    this.productTileHref = this.productTile.querySelector('.product-tile--link').getAttribute('href');
    this.masterSku = this.productTile.getAttribute('data-master-sku');
    this.hideOOSColors = JSON.parse(this.productTile.getAttribute('data-hide-oos-swatches'));
    this.hoverImageEnabled = this.productTile.hasAttribute('data-hover-image');
    this.updateImagesOnClick = JSON.parse(this.productTile.getAttribute('data-swatch-click-update'));
    //window.console.log('ProductTileSwatches masterSku', this.masterSku);

    this.imageWrapper = this.productTile.querySelector('.product--image-wrapper');
    this.mainImageEl = this.productTile.querySelector('.product--image');
    this.hoverImageEl = this.productTile.querySelector('.product--hover-image');
    
    this.updateViewListener();

  }
  disconnectedCallback () {
    //window.console.log('ProductTileSwatches disconnectedCallback')
  }
  updateViewListener () {
    window.on(`theme:producttile:${this.masterSku}:variantsLoaded`,
      ({ detail: { products: t } }) => {
        //console.log('handling variantsLoaded', this.masterSku);
        this.updateSwatches(t);
      }
    );
  }
  updateSwatches(products) {
    var othis = this;
    var productTileHref = this.productTileHref;
    var hideOOSColors = this.hideOOSColors;
    var updateImagesOnClick = this.updateImagesOnClick;
    var radiosRoot = this.querySelectorAll('.radios--root')[0];
    var colorUL = radiosRoot.querySelector('.radios--container');
    var radiosName = colorUL.getAttribute('aria-labelledby');
    var selectedRadio = colorUL.querySelector('.radios--input');
    var currentColor = selectedRadio.value;

    for (var i = 0; i < products.length; i++) {
      var prod = products[i];
      
      if (!('selectedColor' in prod) || prod.selectedColor == '') {
        continue;
      }

      if (prod.selectedColor == currentColor) {
        selectedRadio.parentElement.classList.add('selected');
        selectedRadio.parentElement.setAttribute('data-sort', i);

        this.mainImageEl.setAttribute('data-color', currentColor);
        if (this.hoverImageEl)
          this.hoverImageEl.setAttribute('data-color', currentColor);

        var selectedLabel = selectedRadio.parentElement.querySelector('.radios--swatch-button');
        selectedLabel.setAttribute('data-url', productTileHref);
        selectedLabel.setAttribute('data-product-handle', prod.handle);
        selectedLabel.setAttribute('data-variant-id', prod.selectedOrFirstAvailableVariant.id);
        
      } else {
        if (!prod.available && hideOOSColors) {
          continue;
        }
        var prodSwatchUrl = prod.url;
        try {
          var temp = productTileHref.split('/');
          temp = temp.filter((str) => str !== '');        
          if (temp.indexOf('collections') > -1) {
            var productsIndex = temp.indexOf('products');          
            temp = temp.slice(0, productsIndex);            
            var temp2 = prod.url.split('/');
            temp2 = temp2.filter((str) => str !== '');  
            var urlarr = temp.concat(temp2);          
            var newurl = urlarr.join('/');            
            prodSwatchUrl = '/' + newurl;
          }
        } catch (ex) {}
        
        var radioId = radiosName + '-' + prod.selectedColor.handleize();
        var newRadio = document.createElement('input');
        newRadio.type = 'radio';
        newRadio.classList.add('radios--input');
        newRadio.name = radiosName;
        newRadio.id = radioId;
        newRadio.disabled = true;
        newRadio.value = prod.selectedColor;
        newRadio.setAttribute('data-item', 'radio');
        
        var newLabel = document.createElement('label');
        newLabel.classList.add('radios--swatch-button');
        newLabel.setAttribute('for', radioId);
        newLabel.setAttribute('data-item', 'swatch');
        newLabel.setAttribute('aria-label', prod.selectedColor);
        newLabel.setAttribute('data-url', prodSwatchUrl);
        newLabel.setAttribute('data-product-handle', prod.handle);
        newLabel.setAttribute('data-variant-id', prod.selectedOrFirstAvailableVariant.id);
        
        var newLI = document.createElement('div');
        newLI.classList.add('radios--main');
        newLI.setAttribute('data-sort', i);
        
        newLI.appendChild(newRadio);
        newLI.appendChild(newLabel);
        colorUL.appendChild(newLI);

        this.preloadImages(prod);
      }
    }
    theme.utils.setSwatchColors(colorUL.querySelectorAll('input'));

    Array.from(colorUL.querySelectorAll('.radios--main')).sort(function(a, b) {
      return +a.dataset.sort - +b.dataset.sort;
    }).forEach(e => colorUL.appendChild(e));
    
    var swatchLabels = colorUL.querySelectorAll('.radios--swatch-button');
    for (var x = 0; x < swatchLabels.length; x++) {
      var swatchLabel = swatchLabels[x];
      swatchLabel.addEventListener('click', function (e) {
        if (updateImagesOnClick) {
          if (!this.parentElement.classList.contains('selected')) {
            colorUL.querySelectorAll('.selected').forEach(rr => rr.classList.remove('selected'));
            this.parentElement.classList.add('selected');
            othis.updateImages(this);

            var swatchHref = this.dataset['url'];
            if (swatchHref) {
              othis.productTile.querySelectorAll('.product-tile--link').forEach(aa => aa.href = swatchHref);
            } 
          }
          
        } else {
          if (this.parentElement.classList.contains('selected')) {
            window.location.href = productTileHref;
          } else {
            e.preventDefault();
            e.stopPropagation();
            var swatchHref = this.dataset['url'];
            if (swatchHref) {
              window.location.href = swatchHref;
            }                  
          }
        }
      });      
    }
  }
  preloadImages(prod) {
    var tempId = 'preload-image--' + this.masterSku + '-' + prod.selectedColor.handleize();
    var tempEl = this.imageWrapper.querySelector('.' + tempId);
    if ('plp_image_html' in prod && prod.plp_image_html != null) {
        if (!tempEl) {
          var tempEl = document.createElement('div');
          tempEl.classList.add('product--image');
          tempEl.classList.add('product--hide-image');
          tempEl.classList.add(tempId);
          tempEl.setAttribute('data-item', 'image');
          tempEl.setAttribute('data-color', prod.selectedColor);
          tempEl.insertAdjacentHTML( 'beforeend', prod.plp_image_html );
          this.imageWrapper.appendChild(tempEl);
        }
    }
    if (this.hoverImageEnabled) {
      var tempId2 = 'preload--hover-image--' + this.masterSku + '-' + prod.selectedColor.handleize();
      var tempEl2 = this.imageWrapper.querySelector('.' + tempId2);
      if ('plp_hover_image_html' in prod && prod.plp_hover_image_html != null) {
          if (!tempEl2) {
            var tempEl2 = document.createElement('div');
            tempEl2.classList.add('product--hover-image');
            tempEl2.classList.add('product--hide-image');
            tempEl2.classList.add(tempId2);
            tempEl2.setAttribute('data-color', prod.selectedColor);
            tempEl2.insertAdjacentHTML( 'beforeend', prod.plp_hover_image_html );
            this.imageWrapper.appendChild(tempEl2);
          }
      }      
    }
  }
  updateImages(swatch) {
    //window.console.log('updateImages', swatch);
    var color = swatch.getAttribute('aria-label');
    this.imageWrapper.querySelectorAll('div[data-color="' + color + '"]').forEach(ooo => {
      //ooo.classList.remove('product--preload-image');
      ooo.classList.remove('product--hide-image');
    });
    this.imageWrapper.querySelectorAll('div[data-color]:not([data-color="' + color + '"])').forEach(ddd => ddd.classList.add('product--hide-image'));

    // update the quick add button
    var quickAdd = this.imageWrapper.querySelector('.product--quick-add');
    if (quickAdd) {
      var handle = swatch.getAttribute('data-product-handle');
      var variantId = swatch.getAttribute('data-variant-id');
      
      var clone = quickAdd.cloneNode(true);
      clone.setAttribute('data-handle', handle);
      clone.setAttribute('data-id', variantId);
      this.imageWrapper.appendChild(clone);
      
      // remove the original
      quickAdd.parentNode.removeChild(quickAdd);
    }
  }
}
const productTileSwatchesEl = customElements.get('product-tile-swatches-root')
productTileSwatchesEl || customElements.define('product-tile-swatches-root', ProductTileSwatches)
